// import {displaySetPrice} from "@/utils/priceFormat"
export default {
  namespaced: true,
  state() {
    return {
      clickAlarm: false,
      alarmRegInfo: {
        exchange: "", // 거래소
        quote: "USDT", // 마켓
        coin: "", //코인
        price: 0, //설정금액
        percent: null,
        type: "", // 알람조건
        cycle: "", // 주기
        soundId: null, // 알람소리
        memo: "", // 메모
        currentPrice: 0,
        edit: false,
        sameGroup: false,
      },
      editAlarm: false,
      alarmEditInfo: {
        exchange: "", // 거래소
        quote: "USDT", // 마켓
        coin: "", //코인
        price: 0, //설정금액
        percent: null,
        type: "", // 알람조건
        cycle: "", // 주기
        soundId: 0, // 알람소리
        memo: "", // 메모
        currentPrice: 0,
        edit: false,
      },
    };
  },
  mutations: {
    changeAlarm(state, payload) {
      // console.log(111)
      state.clickAlarm = payload.state;
    },
    regAlarmAtModal(state, payload) {
      state.alarmRegInfo.exchange = payload.exchange;
      state.alarmRegInfo.coin = payload.coin;
      state.alarmRegInfo.percent = payload.percent;
      state.alarmRegInfo.type = payload.type;
      state.alarmRegInfo.cycle = payload.cycle;
      state.alarmRegInfo.soundId = payload.soundId;
      state.alarmRegInfo.currentPrice = payload.currentPrice;
      state.alarmRegInfo.quote = payload.quote;
    },
    resetAlarmModal(state, payload) {
      // console.log("reset info", payload);
      state.alarmRegInfo = payload;
    },
    resetPercent(state, payload) {
      // console.log("resetPercent", payload);
      state.alarmRegInfo.percent = payload.percent;
    },
    priceTotal(state, payload) {
      // console.log("priceTotal", payload);
      // setPrice = displaySetPrice(setPrice, state.alarmRegInfo.currentPrice);
      state.alarmRegInfo.price = payload.setPrice.toLocaleString(); // 직접 state를 변이
      // }
    },
    setMemoState(state, payload) {
      state.alarmRegInfo.memo = payload.memo;
    },
    editAlarmState(state, payload) {
      // console.log("edit state 전달", payload);
      state.alarmRegInfo = payload;
      // // console.log('state.alarmRegInfo',state.alarmRegInfo);
    },
    updateCurrentPrice(state, payload) {
      // console.log("updateCurrentPrice", payload);
      state.alarmRegInfo.currentPrice = payload.currentPrice;
    },
    changeEditAlarm(state, payload) {
      state.editAlarm = payload.state;
    },
    updateGroupAlarm(state, payload) {
      // console.log(payload);
      state.alarmRegInfo = payload;
      // state.alarmRegInfo.exchange = payload.exchange
      // state.alarmRegInfo.coin = payload.coin
    },
  },
  actions: {
    // updatePriceTotal({ commit, state }, payload) {
    //   const setPrice = displaySetPrice(payload.setPrice, state.alarmRegInfo.currentPrice);
    //   commit('priceTotal', { setPrice });
    // }
  },
};
